import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { Formik, Field } from 'formik';
import { Form, Input, Button, Alert, message } from 'antd';
import { FormInputField } from '../FormInputField/FormInputField';
import { FolderOutlined, LinkOutlined, LoadingOutlined } from '@ant-design/icons';
import validators from '../../validators/validators';
import { mutations, queries } from '../../graphql/graphql';

import { DirectoryValuesInput } from './DirectoryValuesInput';

const DirectoryUpdate = ({ match, history }) => {
  const [values, setValues] = useState([]);
  const [DIRECTORY_UPDATE] = useMutation(mutations.DIRECTORY_UPDATE);

  const { params } = match;
  const { id } = params;
  const { loading, data = {} } = useQuery(queries.DIRECTORY, { variables: { id } });
  const { directory = {} } = data;

  useEffect(() => {
    if (directory) {
      setValues(directory.values);
    }
  }, [data]);

  const handleSubmitForm = async (form, actions) => {
    const { name, slug } = form;
    const { setErrors, setSubmitting } = actions;
    setSubmitting(true);
    const input = {
      name,
      slug,
      values: values.map(value => {
        delete value.__typename;
        return value;
      })
    };

    DIRECTORY_UPDATE({
      variables: {
        id,
        input
      }
    }).then(
      res => {
        const { data } = res;
        const { updateDirectory } = data;
        message.success('Directory successfully updated');
        setSubmitting(false);
        history.push(`/directory/${updateDirectory.id}`);
      },
      err => {
        const errors = {};
        err.graphQLErrors.map(x => {
          console.log(x);
          if (x.message.includes('slug')) {
            errors.name = 'Slug has already been taken.';
          }
        });
        setSubmitting(false);
        setErrors(errors);
      }
    );
  };

  if (loading)
    return (
      <LoadingOutlined
        style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}
      />
    );

  return (
    <div
      style={{
        display: 'block',
        width: '100vw',
        height: '100vh',
        padding: 0,
        background: '#ffffff'
      }}
    >
      <Formik
        initialValues={{ name: directory.name || '', slug: directory.slug || '', values }}
        validationSchema={validators.directorySchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleSubmitForm}
        render={formikProps => {
          const { errors, isSubmitting, handleSubmit, submitForm } = formikProps;

          return (
            <div style={{ padding: 50 }}>
              {Object.keys(errors).length > 0 && (
                <Alert
                  message={errors.name || errors.slug}
                  type="error"
                  showIcon
                  style={{ marginBottom: '1.05rem', maxWidth: '300px' }}
                />
              )}
              <Form onSubmit={handleSubmit}>
                <Field
                  InputType={Input}
                  component={FormInputField}
                  prefix={<FolderOutlined />}
                  name="name"
                  placeholder="Name"
                  hideErrorMessage={true}
                />
                <Field
                  InputType={Input}
                  component={FormInputField}
                  prefix={<LinkOutlined />}
                  name="slug"
                  placeholder="Slug"
                  hideErrorMessage={true}
                />
                <Field
                  InputType={DirectoryValuesInput}
                  component={FormInputField}
                  onChange={setValues}
                  name="values"
                  placeholder=""
                  value={values}
                />
                <Form.Item style={{ marginBottom: 'unset' }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isSubmitting}
                    onClick={submitForm}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Form>
            </div>
          );
        }}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

DirectoryUpdate.propTypes = {
  user: PropTypes.object.isRequired
};

const connectedUpdate = connect(mapStateToProps, mapDispatchToProps)(DirectoryUpdate);

export default connectedUpdate;
